import React, { useRef, useState } from "react";
import Markdown from "react-markdown";
import ArrowRight from "assets/svgs/button-arrow-right.svg";
import Button from "components/Button";
import RichText from "./RichText";

const Overlay = () => (
  <div
    style={{
      backgroundImage:
        "linear-gradient(180deg, rgba(250, 250, 250, 0) -52.5%, rgba(250, 250, 250, 0.53185) 15.01%, #FAFAFA 82.46%)",
      bottom: 0,
      height: 200,
      left: 0,
      position: "absolute",
      right: 0,
      zIndex: 10,
    }}
  ></div>
);

const About = ({ descriptionHtml, narrative, first_name, last_name }) => {
  const [isOpen, setIsOpen] = useState(false);
  const aboutRef = useRef(null);
  const hasOverflow = aboutRef.current?.clientHeight > 600;

  return (
    <article
      className={`bg-white border overflow-hidden	pt-5 px-5 relative rounded`}
      ref={aboutRef}
      style={{
        height: hasOverflow ? "600px" : "auto",
        paddingBottom: hasOverflow || isOpen ? "64px" : "18px",
      }}
    >
      <h2 className="highlight mb-4">Overview of {first_name} {last_name}</h2>
      {narrative ? (
        <RichText portableText={narrative} />
      ) : (
        <Markdown className="longform">{descriptionHtml}</Markdown>
      )}
      {(hasOverflow || isOpen) && (
        <>
          <div className="absolute bottom-4 flex items-center justify-center left-0 mx-auto right-0 z-20">
            <Button
              className="text-sm w-32"
              emphasis="secondary"
              onClick={() => setIsOpen(!isOpen)}
              height="32"
            >
              <ArrowRight
                className={`${
                  isOpen ? "-rotate-90" : "rotate-90"
                } mr-2 transform`}
                width="6"
              />{" "}
              {isOpen ? "Collapse" : "Expand"}
            </Button>
          </div>
          {!isOpen && <Overlay />}
        </>
      )}
    </article>
  );
};

export default About;
